export enum TargetGroupListColumns {
  'ID' = 'ID',
  'CREATED_DATE' = 'Created Date',
  'NAME' = 'Name',
  'TYPE' = 'Type',
  'USER_COUNT' = 'Users in Segment'
}
export const TARGET_GROUPS_FILTERS_KEYS = {
  SEARCH: 'searchGroupNameInput',
  CREATED_DATE: 'createDateRange',
  TYPES: 'selectedGroups'
}
export const TARGET_GROUP_TYPE = {
  MANUAL: 'Manual',
  AUTOMATIC: 'Automatic',
  INVITE: 'Invite Code'
} as const
export const CAMPAIGN_TYPE_FOR_INVITE_TYPE = 'PROMOTION'
export const INVITE_CODE_SEGMENT_NAME = 'inviteCodeSegmentName'
export const TARGET_GROUP_LEFT_SECTION_TITLES = {
  USERS: 'Users in Segment',
  CAMPAIGNS: 'Campaigns',
  OFFERS: 'Offers',
  UPDATE_CARDS: 'Update Cards',
  PROVIDERS: 'Providers',
  ACTION_BOXES: 'Action Boxes',
  DESCRIPTION: 'Description',
  EXPIRATION_DATE: 'Expiration Date',
  AVAILABLE_CODES: 'Available Codes',
  TITLE: 'Title'
}

export const INFINITE = 'Infinite'
export const SEGMENT = 'Segment'

export const TARGET_GROUP_LEFT_SECTION_DESCRIPTIONS = {
  USERS: 'Users',
  CAMPAIGNS_INCLUDED: 'Campaigns Included',
  CAMPAIGNS_EXCLUDED: 'Campaigns Excluded',
  OFFERS_INCLUDED: 'Offers Included',
  OFFERS_EXCLUDED: 'Offers Excluded',
  PROVIDERS_INCLUDED: 'Providers Included',
  PROVIDERS_EXCLUDED: 'Providers Excluded',
  UPDATE_CARDS_INCLUDED: 'Updates Included',
  UPDATE_CARDS_EXCLUDED: 'Updates Excluded',
  ACTION_BOXES_INCLUDED: 'Action Boxes Included',
  ACTION_BOXES_EXCLUDED: 'Action Boxes Excluded',
  CODES: 'Codes'
}

export const NO_RESULTS = 0

export const GROUP_MANUAL_TABS = [
  'Users in Segment',
  'Campaigns',
  'Offers',
  'Updates',
  'Providers',
  'Action Box',
  'Failure Logs',
  'Masabi Failure Logs'
]

export const GROUP_MANUAL_TABS_INDEX = {
  USERS_IN_SEGMENT: 0,
  CAMPAIGNS: 1,
  OFFERS: 2,
  UPDATES: 3,
  PROVIDERS: 4,
  ACTION_BOXES: 5,
  FAILURE_LOGS: 6,
  MASABI_FAILURE_LOGS: 7
}

export const GROUP_INVITE_TABS = [
  'Settings',
  'Available Codes',
  'Users in Segment',
  'Campaigns',
  'Offers',
  'Updates',
  'Providers',
  'Action Box',
  'Translations',
  'Masabi Failure Logs'
]

export const GROUP_INVITE_TABS_INDEX = {
  SETTINGS: 0,
  AVAILABLE_CODES: 1,
  USERS_IN_SEGMENT: 2,
  CAMPAIGNS: 3,
  OFFERS: 4,
  UPDATES: 5,
  PROVIDERS: 6,
  ACTION_BOXES: 7,
  TRANSLATIONS: 8,
  MASABI_FAILURE_LOGS: 9
}

export const SETTINGS_IMAGE = {
  WIDTH: 180,
  HEIGHT: 100
}

export const REWARDS_TYPE = {
  POINTS: 'Points',
  NONE: 'None'
}

export const SETTINGS_CODE_TITLES = {
  CODE: 'Code Settings',
  TIMES_USER: 'Number of times a user can enter a code from the Segment',
  TIMES_CODE: 'Number of times each code can be used',
  METHOD: 'Method to Generate the Codes',
  TYPE: 'Type of Reward when entering a code',
  POINTS_ENTERED: 'Number of Points to give when a code is entered',
  TRANSACTION: 'Earning transaction Title',
  EXPIRATION: 'Points expiration Date',
  PREFIX: 'Prefix',
  RANDOM: 'Random Section Length',
  EXCLUDED: 'Excluded Characters'
}

export const SETTINGS_WELCOME_TITLES = {
  WELCOME: 'Welcome Dialog',
  WELCOME_DESCRIPTION:
    'Users will see this dialog when they enter a code from this Segment',
  IMAGE: 'Welcome Dialog Image',
  TITLE: 'Welcome Dialog Title',
  DESCRIPTION: 'Welcome Dialog Description',
  CTA: 'Welcome Dialog CTA label'
}

export const GROUP_MORE_BUTTON_LABELS = {
  DELETE: 'Delete Code',
  DOWNLOAD_CODES: 'Download Available Codes',
  DOWNLOAD_USERS: 'Download list of Users',
  DOWNLOAD_REPORT: 'Download Report'
}

export const GROUP_FILTERS = {
  SEARCH: 'search',
  JOIN_DATE: 'registrationDateRange',
  STATUS: 'selectedStatuses'
}

export const GROUP_USERS_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED'
}

export const GROUP_CODES_TABLE_COLUMNS = [
  'Created Date',
  'Reward Code',
  'Type',
  'Available Codes',
  ' '
]

export const GROUP_USERS_TABLE_COLUMNS = [
  'UserID',
  'Join Date',
  'Name',
  'Email',
  'Status'
]

export const GROUP_CODE_TYPES = {
  UNIQUE: 'Unique',
  REPEATABLE: 'Repeatable'
}

export const CODE_DELETED_NUMBER = 1

export const GROUP_PROVIDERS_TABLE_COLUMNS = ['ID', 'Name']

export const GROUP_CAMPAIGNS_TABLE_COLUMNS = [
  'ID',
  'Category',
  'Title',
  'Status',
  'Start Date',
  'End Date'
]

export const GROUP_OFFERS_TABLE_COLUMNS = [
  'ID',
  'Category',
  'Title',
  'Status',
  'Codes Available',
  'Codes Redeemed',
  'Segment Redemptions'
]

export const GROUP_UPDATES_TABLE_COLUMNS = ['ID', 'Name', 'Title', 'Status']

export const ROW_STYLE = 'flex flex-row justify-between p-3 mt-5'
export const COL_STYLE = 'flex flex-col w-3/5 space-y-3'

export const MANUAL_GROUP_TITLES = {
  CREATE_MANUAL: 'New Manual Segment',
  EDIT_MANUAL: 'Edit Manual Segment',
  INFORMATION: 'Segment Information',
  NAME: 'Segment Name',
  LIST: 'List of Users to include (optional)',
  CURRENT_USERS: 'Users currently included on the Segment:',
  EDIT_LIST: 'Edit list of Users:'
}

export const MANUAL_GROUP_SUBTITLES = {
  INFORMATION: 'Provide the following information related to the Segment.',
  DOWNLOAD: 'Download Sample File.',
  LIST: 'The file should have the following structure: userID',
  NO_RECORDS: 'There are no valid users to be added to the Segment.',
  EDIT_LIST_REPLACE:
    'Upload a .csv files with the list of users that are going to be replacing the current list.',
  EDIT_LIST_ADD:
    'Upload a .csv file with the list of users that are going to be included in the current list.'
}

export const MANUAL_GROUP_HEADERS = ['userID']

export const MANUAL_GROUP_POP_UP_TYPE = {
  WRONG_HEADERS: 'WRONG_HEADERS',
  WITHOUT_CSV: 'WITHOUT_CSV',
  VALID: 'VALID',
  UPLOAD: 'UPLOAD',
  REPLACE: 'REPLACE',
  REMOVE: 'REMOVE',
  NO_CHANGE: 'NO_CHANGE'
} as const

export const MANUAL_GROUP_POP_UP_LABELS = {
  WRONG_HEADERS: {
    message:
      'Incorrect file headers. The file should have the following column headers: userID',
    details: '',
    title: 'Error on File Headers',
    buttonLabel: 'Go Back',
    buttonVariant: 'primary',
    showInfo: false,
    showCount: false
  },
  WITHOUT_CSV: {
    message: 'Create the Manual Segment',
    details: 'There will be no users included in this group.',
    title: 'Create Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: false,
    showCount: false
  },
  VALID: {
    message: 'Create the Manual Segment',
    details: '',
    title: 'Create Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: true,
    showCount: true
  },
  UPLOAD: {
    message: 'Update the Manual Segment',
    details: '',
    title: 'Update Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: true,
    showCount: true
  },
  REPLACE: {
    message: 'Update the Manual Segment',
    details: '',
    title: 'Update Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: true,
    showCount: true
  },
  REMOVE: {
    message: 'Update the manual Segment',
    details:
      'All Users ({{userCount}} Users) will be removed from the segment.',
    title: 'Update Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: false,
    showCount: false
  },
  NO_CHANGE: {
    message: 'Update the manual Segment',
    details: 'There will be no modifications made to the User List.',
    title: 'Update Manual Segment',
    buttonLabel: 'Cancel',
    buttonVariant: 'secondary',
    showInfo: false,
    showCount: false
  }
} as const

export const USER_LIST_ACTIONS = {
  UPLOAD: 'Upload a list with new users',
  REPLACE: 'Replace the current list of users with a new list',
  REMOVE: 'Remove all users from this segment',
  NO_CHANGE: "Don't make modifications to the user list"
} as const

export const CREATE_OR_UPDATE_INVITE_CODE_SEG_TABS_INDEX = {
  INFORMATION: 0,
  CODE_SETTINGS: 1
} as const

export const CREATE_OR_UPDATE_INVITE_CODE_SEG_TABS = [
  'Information',
  'Codes Settings'
]

export const INVITE_CODE_SEGMENT_TITLES = {
  CREATE_TITLE: 'Create Invite Code Segment',
  EDIT_TITLE: 'Edit Invite Code Segment',
  INFORMATION: 'Segment Information',
  NAME: 'Segment Name',
  REWARDS_SEGMENT_TITLE: 'Segment Title',
  DESCRIPTION: 'Description',
  IS_EXPIRY_DATE_SELECTED: 'Set a Segment Expiration Date?',
  IS_BLOCK_SIGNUP_BONUS:
    'Block SignUp Bonus when entering the segment from the Welcome Screen',
  IS_DISPLAY_WELCOME_DIALOG: 'Display a Welcome Dialog?',
  WELCOME_IMAGE: 'Image',
  WELCOME_TITLE: 'Title',
  WELCOME_MESSAGE: 'Description',
  WELCOME_LABEL: 'Button Label',
  CODES_SETTINGS: 'Codes Information',
  TIMES_CAN_BE_ENTERED_BY_USER:
    'Number of times a user can enter a code from the Segment',
  TIMES_CAN_BE_USED: 'Number of times each code can be used',
  REWARD_TYPE: 'Type of Reward when entering a code',
  POINTS: 'Points',
  NONE: 'None',
  WELCOME_POINTS: 'Number of points to give when a code is entered',
  WELCOME_POINTS_TITLE: 'Earning Transaction Title',
  IS_POINTS_EXPIRY_DATE_SELECTED: 'Expire Earned Points',
  CODE_GENERATE_METHOD: 'Method to Generate the Codes',
  CODES: 'List of Codes',
  CODE_GENERATION: 'Generation of Invite Codes',
  PREFIX: 'Code Prefix (optional)',
  NUM_OF_CODES: 'Number of codes to generate',
  RANDOM_LENGTH: 'Random section length',
  AVAILABLE_CODES: 'Available Codes',
  TYPE_OF_CODES: 'Type of Codes',
  CODE_MODIFICATION: 'Edit list of Available Codes',
  DELETE_CODES: 'Delete all available codes',
  REPLACE_CODES: 'Replace list of available codes with new codes',
  MODIFY_REPEAT_TIMES: 'Modify the number of times the code can be repeated',
  MANUALLY_ADD_CODES: 'Manually add more codes',
  NO_MODIFICATIONS: 'Don’t make any modifications',
  GENERATE_CODES: 'Generate more codes',
  UPLOAD_CSV: 'Upload a list with the new codes',
  EXCLUDED_CHARS: 'Characters to exclude (optional)'
}

export const INVITE_CODE_SEGMENT_SUBTITLES = {
  INFORMATION: 'Provide the following information related to the Segment.',
  CODES_SETTINGS:
    'Provide the information required to set up the Invite Codes.',
  CODE_GENERATION:
    'Provide the following information to create the New Invite Codes for this segment.',
  CODE_MODIFICATION:
    'Select the modification to make to the list of codes that are currently available.',
  UPLOAD_CSV: 'The .csv file should have the following structure: codes',
  EXCLUDED_CHARS: 'Comma-separated list of characters'
}

export const INVITE_CODE_SEGMENT_KEYS = {
  NAME: 'name',
  REWARDS_SEGMENT_TITLE: 'RewardsSegmentTitle',
  DESCRIPTION: 'description',
  IS_EXPIRY_DATE_SELECTED: 'isExpirationDateSelected',
  EXPIRY_DATE: 'expiryDate',
  IS_BLOCK_SIGNUP_BONUS: 'isBlockSignUpBonusSelected',
  IS_DISPLAY_WELCOME_DIALOG: 'isDisplayWelcomeDialog',
  WELCOME_IMAGE: 'welcomeDialogImageID',
  WELCOME_TITLE: 'welcomeDialogTitle',
  WELCOME_MESSAGE: 'welcomeDialogMessage',
  WELCOME_LABEL: 'welcomeDialogLabel',
  TIMES_CAN_BE_ENTERED_BY_USER: 'timesCanEnteredByUser',
  TIMES_CAN_BE_USED: 'timesCanBeUsed',
  REWARD_TYPE: 'rewardTypeRadioOptionSelected',
  WELCOME_POINTS: 'welcomePoints',
  WELCOME_POINTS_TITLE: 'welcomePointsTitle',
  IS_POINTS_EXPIRY_DATE_SELECTED: 'isPointsExpirationDateSelected',
  POINTS_EXPIRY_DATE: 'pointsExpiryDate',
  CODE_GENERATE_METHOD: 'codeGenerateMethod',
  CODES: 'codes',
  PREFIX: 'prefix',
  NUM_OF_CODES: 'numOfCodes',
  RANDOM_LENGTH: 'randomLength',
  MODIFICATION_TYPE: 'modificationType',
  EXCLUDED_CHARS: 'excludedCharacters'
}

export const INVITE_CODE_SEGMENT_REWARD_TYPE = [
  {
    key: INVITE_CODE_SEGMENT_TITLES.POINTS,
    label: 'points'
  },
  { key: INVITE_CODE_SEGMENT_TITLES.NONE, label: 'none' }
]

export const MANUAL = 'Manual'
export const AUTOMATIC = 'Automatic'

export const SEGMENT_CODES_GENERATION_METHODS = [MANUAL, AUTOMATIC].map((
  method
) => ({
  label: method,
  value: method
}))

export const SEGMENT_RANDOM_LENGTH_OPTIONS = ['4', '5', '6'].map((length) => ({
  label: length,
  value: length
}))

export const CODES_CSV_FILE_HEADERS = ['codes']
export const CODES_CSV_FILE_STRUCTURE_ERROR =
  'The file should only have the column: codes'

export const SEGMENT_TRANSLATIONS_COLUMN_NAME: SegmentTranslationsFields = {
  Name: 'Segment Name',
  Title: 'Points Earning Title',
  Description: 'Description',
  WelcomeTitle: 'Dialog - Title',
  WelcomeDescription: 'Dialog - Description',
  WelcomeButtonLabel: 'Dialog - CTA Label'
}

export const SEGMENT_TRANSLATIONS_KEYS = [
  'Name',
  'Title',
  'Description',
  'WelcomeTitle',
  'WelcomeDescription',
  'WelcomeButtonLabel'
]

export const TARGET_GROUP_USERS_TABLE_COLUMNS = {
  ID: 0,
  SIGNUP_DATE: 1,
  NAME: 2,
  EMAIL: 3,
  STATUS: 4
}

export const NO_RECORDS = 0
export const MSB_ACCOUNT_ID_CSV_HEADERS = [
  'school',
  'accountId',
  'email',
  'channel',
  'productQuantity',
  'fareType',
  'ticketType',
  'ticketIds',
  'comment',
  'Result',
  'Date'
]
export const UPLOAD_MSB_ACCOUNT_IDS_HEADING =
  'Upload a New File for Masabi AccountIDs'
export const MSB_ACCOUNT_IDS_UPLOADER = {
  TITLE: 'List of AccountIDs',
  DESCRIPTION:
    'The file should have the following structure: school,accountId,email,channel,productQuantity,fareType,ticketType,ticketIds,comment,Result,Date'
}

export const GROUP_MASABI_FAILURE_LOGS_TABLE_COLUMNS = [
  'AccountID',
  'Upload Attempt',
  'Error'
]

export const GROUP_ACTION_BOXES_TABLE_COLUMNS = [
  'ID',
  'Category',
  'Title',
  'UI Position',
  'Launch Date'
]

export const GROUP_FAILURE_LOGS_TABLE_COLUMNS = [
  'UserID',
  'Upload Attempt',
  'Error'
]
